var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"loading":_vm.loading,"value":_vm.value,"items":_vm.items,"item-text":"title","item-value":"value","label":"محدوده گزارش","rules":_vm.requiredRules},on:{"input":v => _vm.$emit('input', v),"change":v => _vm.$emit('input', v)}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }